<template>
  <div class="d-flex" style="min-height: 45vw;">
    <div class="content p-4 w-100">

      <!-- HEADER -->
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mt-0">
          {{ i18n.global.t('pages.firmwareBulkUpdate.listTitle') }}
        </h4>
          <router-link
            :to="{name: 'FirmwareBulkUpdateForm'}"
          >
            <v-btn
              class="exec-btn"
            >
              {{ i18n.global.t('pages.firmwareBulkUpdate.createBtn') }}
            </v-btn>
          </router-link>

      </div>

      <!-- MAIN CONTENT -->
      <v-row class="mt-4">
        <v-col>
          <BulkUpdateList
            :showFlash="props.showFlash"
          />
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script setup lang="ts">
import BulkUpdateList from '@/components/Firmware/BulkUpdate/BulkUpdateList.vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  showFlash: (message: string, type: string, fadeout: boolean) => void
}>()

</script>

<style scoped>
.content {
  min-width: 58vw;
}
</style>
